var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTime = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 12h-2v-2c0-.553-.448-1-1-1s-1 .447-1 1v3c0 .553.448 1 1 1h3c.552 0 1-.447 1-1 0-.553-.448-1-1-1zm-3 7.75c-3.722 0-6.75-3.028-6.75-6.75S8.278 6.25 12 6.25s6.75 3.028 6.75 6.75-3.028 6.75-6.75 6.75zm.988-15.692C12.99 4.037 13 4.021 13 4V3h1c.552 0 1-.447 1-1 0-.553-.448-1-1-1h-4c-.552 0-1 .447-1 1 0 .553.448 1 1 1h1v1c0 .021.01.037.012.058C6.513 4.552 3 8.372 3 13c0 4.963 4.038 9 9 9s9-4.037 9-9c0-4.628-3.513-8.448-8.012-8.942z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/time.05f07163.svg";
export { ForwardRef as ReactComponent };